<template>
  <div>
    <div class="items-center flex" v-if="!isFetchAssetsLoaded">
      <svg class="animate-spin h-3 w-3 mr-3 bg-yellow-500 inline-block" viewBox="0 0 24 24"></svg><span class="text-gray-500 text-sm">Fetching assets...</span>
    </div>
    <div v-else>
      <div class="mb-5 text-sm" v-if="displayAssets.length > 0">Select a {{ network }} token to import:</div>
      <div v-for="asset in displayAssets" @click="selectedAssetId = asset.assetID" :key="asset.assetID" class="p-5 transition-all duration-200 mt-1 bg-black-card cursor-pointer hover:bg-black-sidebar text-white">
        <div class="flex justify-between items-center">
          <div>
            {{ asset.assetID }}
            <div v-if="asset.names.length > 0" class="mt-2 text-gray-text text-xs">
              <span v-for="name, index in asset.names" :key="name">{{ (index > 0)?' ,':'' }}{{ name }}</span>
            </div>
          </div>
          <div><div class="text-xs text-gray-text text-right mb-1">Supply</div><div class="text-sm font-bold text-right">{{ Helper.convertToCurrency(parseFloat(asset.supply)) }}</div></div>
        </div>
        <tokensImportAssetFormComponent :network="network" class="mt-5 bg-black-primary rounded-md p-3" @closeForm="closeInputForm" v-if="selectedAssetId === asset.assetID" :supply="parseFloat(asset.supply)" :assetId="asset.assetID" :publicKey="publicKey" :divisibility="asset.divisibility" />
      </div>
      <div class="navigation_div" v-if="loadedAssets.length > 10">
        <div class="navigation-num">
          Show
          <select v-model="pages" class="" @change="changeRows">
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="40">40</option>
            <option value="50">50</option>
          </select>
          Records
        </div>
        <div class="navigation-menu">
          <div v-if="enableFirstPage" @click="naviFirst" class="option">First</div>
          <div v-if="enablePreviousPage" @click="naviPrevious" class="option">
            Previous
          </div>
          <div v-else class="option-disabled">Previous</div>
          <div class="navigation-text">
            Page {{ currentPage }} of {{ totalPages }}
          </div>
          <div v-if="enableNextPage" @click="naviNext" class="option">Next</div>
          <div v-else class="option-disabled">Next</div>
          <div v-if="enableLastPage" @click="naviLast" class="option">Last</div>
          <div v-else class="option-disabled">Last</div>
        </div>
      </div>
    </div>
    <div v-if="isNoAssetsFound">No asset is found</div>
  </div>
</template>

<script>
import { ref, computed } from "vue";
import { useStore } from 'vuex';
import tokensImportAssetFormComponent from "@/modules/tokens/components/tokensImportAssetFormComponent.vue";
import { Helper } from "@/utils/Helper";
import { useRouter, useRoute } from "vue-router";
import { TokenUtils } from "@/utils/TokenUtils";
export default{
  name: 'tokensImportAssetComponent',
  props: {
    publicKey: String,
  },
  components: {
    tokensImportAssetFormComponent,
  },
  setup(props, {emit}){
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const isNoAssetsFound = ref(false);
    const isFetchAssetsLoaded = ref(false);
    const selectedAssetId = ref('');
    const displayAssets = ref([]);
    const loadedAssets =  ref([]);
    const userData = store.getters['auth/user'];

    //pagination
    const totalAssets = ref(0);
    const pages =  ref(20);
    const currentPage = ref(1);
    const totalPages = ref(0);

    // pagination
    const enableFirstPage = computed(()=> {
      return currentPage.value > 1;
    });

    const enablePreviousPage = computed(() => {
      return currentPage.value > 1;
    });

    const enableNextPage = computed(() => {
      return totalPages.value - currentPage.value > 0;
    });

    const enableLastPage = computed(() => {
      return currentPage.value < totalPages.value;
    });

    const network = computed(() => {
      return Helper.capitalizeFirstLetter(route.params.network);
    });

    const fetchAssets = async () => {
      // fetch assets
      isFetchAssetsLoaded.value = false;
      const assets = await TokenUtils.getWalletUnusedAssets(network.value=='Testnet'?userData.testnetWalletAddress:userData.mainnetWalletAddress, network.value=='Testnet'?'testnet':'mainnet');
      isFetchAssetsLoaded.value = true;
      if(assets.length > 0){
        loadedAssets.value = assets;
      }else{
        isFetchAssetsLoaded.value = true;
        isNoAssetsFound.value = true;
      }
      loadAssets();
    };
    fetchAssets();

    const loadAssets = () => {
      totalPages.value = Math.ceil(loadedAssets.value.length / pages.value);
      displayAssets.value = loadedAssets.value.slice(
        (currentPage.value - 1) * pages.value,
        Number((currentPage.value - 1) * pages.value) + Number(pages.value)
      );
    };

    const closeInputForm = () => {
      selectedAssetId.value = '';
    };

    // pagination
    const naviFirst = () => {
      currentPage.value = 1;
      loadAssets();
    };

    const naviPrevious =() => {
      --currentPage.value;
      loadAssets();
    };

    const naviNext = () => {
      ++currentPage.value;
      loadAssets();
    };

    const naviLast = () => {
      currentPage.value = totalPages.value;
      loadAssets();
    };

    const changeRows = () => {
      loadAssets();
    }


    return{
      network,
      Helper,
      isNoAssetsFound,
      isFetchAssetsLoaded,
      selectedAssetId,
      displayAssets,
      loadedAssets,
      closeInputForm,

      // pagination
      enableFirstPage,
      enablePreviousPage,
      enableNextPage,
      enableLastPage,
      totalAssets,
      pages,
      currentPage,
      totalPages,
      naviFirst,
      naviPrevious,
      naviNext,
      naviLast,
      changeRows,

    }
  },

  emits:[
    
  ],
}
</script>
<style lang="scss" scoped>
</style>